import React from 'react';

import brandLogo from '../images/kalinga/brand-logo.png';

const navigation = {
  links: [
    { name: 'Projects', href: '/projects' },
    { name: 'Project Kalinga', href: '/projects/kalinga' },
    { name: 'Due Diligence', href: '/diligence' },
    { name: 'Contact', href: '/contact' },
  ],
};

function Footer() {
  return (
    <footer className="theme-default-raised bg-background text-foreground pt-14 md:pt-16 pb-8 md:pb-14">
      <div className="max-w-screen-xpad mx-auto px-4 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          <div className="md:col-span-5">
            <img
              src={brandLogo}
              alt="LongStraw Carbon"
              width="160"
              height="160"
              className="h-14 w-auto mb-6"
            />
            <p className="text-lg leading-relaxed text-muted-foreground max-w-md">
              Turning agricultural residues into durable carbon removal and
              restoring agricultural soil health across the Global South.
            </p>
          </div>
          <div className="md:col-span-3 md:col-start-7">
            <div className="font-mono font-medium text-base text-muted-foreground mb-4">
              Navigation
            </div>
            <ul className="list-none space-y-3">
              {navigation.links.map(({ name, href }) => (
                <li key={name}>
                  <a href={href} className="link-mono">
                    {name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-3 md:col-start-10">
            <div className="font-mono font-medium text-base text-muted-foreground mb-4">
              Contact
            </div>
            <ul className="list-none space-y-3">
              <li>
                <a
                  href="mailto:contact@longstrawcarbon.com"
                  className="link-mono"
                >
                  contact@longstrawcarbon.com
                </a>
              </li>
              <li>
                <a
                  href="https://registry.isometric.com/project/6PQZ"
                  className="link-mono"
                >
                  Isometric registry: 6PQZ
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-border">
          <p className="font-mono text-sm text-muted-foreground">
            &copy; {new Date().getFullYear()} LongStraw Carbon. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
